import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=843e1ab8&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=843e1ab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843e1ab8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('843e1ab8')) {
      api.createRecord('843e1ab8', component.options)
    } else {
      api.reload('843e1ab8', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=843e1ab8&scoped=true&", function () {
      api.rerender('843e1ab8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4njsdLpCYcKIh/JS/teamMember.vue"
export default component.exports